import { LegendOptions } from '@sprinklr/stories/hyperspaceWidgets/types';
import { AsidePosition } from '@sprinklr/spaceweb-charts/components/chartWrapper/types';

export function getLegendPosition(
    legend: LegendOptions,
    defaultPosition: AsidePosition = 'top'
): AsidePosition {
    let { selectedPosition } = legend.position;
    if (legend.position.auto) {
        selectedPosition = defaultPosition;
    }
    return selectedPosition || defaultPosition;
}
